import React from 'react';

const VenuesPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Sports Venues</h1>
      <p className="text-gray-600">Venue listing and search functionality will be implemented here</p>
    </div>
  );
};

export default VenuesPage; 